import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCartTotals from 'store/cart/selector/getCartTotals';
import styles from './OrderSummaryBreakDown.module.scss';

const OrderSummaryBreakDown: React.FC = () => {
  const totals = useSelector(getCartTotals);
  const { t } = useTranslation();

  return (
    <div className={styles.priceBreakDown}>
      <div>
        <b>{t('txt_products_subtotal')}:</b>
        <div
          dangerouslySetInnerHTML={{
            __html: t('txt_including_vat', { price: String(totals?.productTotalVat?.formatted) }),
          }}
        />
      </div>
      <div className={styles.price}>
        <b dangerouslySetInnerHTML={{ __html: String(totals?.productTotal?.formatted) }} />
      </div>
      <div>
        <b>{t('txt_estimated_delivery_price')}:</b>
        <div>{t('txt_accurate_price_at_checkout')}</div>
      </div>
      <div className={styles.price}>
        <b dangerouslySetInnerHTML={{ __html: String(totals?.shippingTotal?.formatted) }} />
      </div>
    </div>
  );
};

export default OrderSummaryBreakDown;
